const Logo = (props) => (
  <img
    alt="Logo"
    src="/static/images/Logo-apiborne-V1-betatest-2.svg"
    height={props.heightlogo ? props.heightlogo : "50px"}
    {...props}
  />
);

export default Logo;
